import type { NextPage, NextPageContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getProductMenu } from "@libraries/api/product-menu/product-menu.repos";
import { TProductIconData } from "@layouts/Main/lib/Header/lib/MenuProduct/type";
import PrivacyContainers from "@containers/Policy/Privacy";
import { localeKey } from "@constants/locale-key";
import { getPolicy } from "@libraries/api/policy/policy.repos";

export interface IPropsPagePrivacyPolicy {
  dataPolicy: {
    content: string;
    toc: string[];
  };
  dataNavbar: TProductIconData[];
}

const PrivacyPolicy: NextPage<IPropsPagePrivacyPolicy> = (props) => {
  return (
    <>
      <PrivacyContainers {...props} />
    </>
  );
};

export const getServerSideProps = async (context: NextPageContext) => {
  const { data: dataProductMenu } = await getProductMenu({ level: 0 }, `${context.locale}`);
  const { data: dataPolicyResp } = await getPolicy('privacy');

  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? "id", localeKey)),
      title: "Kebijakan Privasi",
      description: "Kebijakan Privasi",
      imageUrl: "",
      dataNavbar: dataProductMenu as TProductIconData[],
      dataPolicy: dataPolicyResp,
    },
  };
};

export default PrivacyPolicy;
